import carta1 from '../../../resources/images/resizedResto/carta1.png';
import carta2 from '../../../resources/images/resizedResto/carta2.png';
import carta3 from '../../../resources/images/resizedResto/carta3.png';
import carta4 from '../../../resources/images/resizedResto/carta4.png';
import carta5 from '../../../resources/images/resizedResto/carta5.png';
import carta6 from '../../../resources/images/resizedResto/carta6.png';
import carta7 from '../../../resources/images/resizedResto/carta7.png';
import carta8 from '../../../resources/images/resizedResto/carta8.png';
import carta9 from '../../../resources/images/resizedResto/carta9.png';
import carta10 from '../../../resources/images/resizedResto/carta10.png';
import SingleSectionTable from './SingleSectionTable';
import TwoSectionTable from './TwoSectionTable/TwoSectionTable';
import vinoConfig from './vinoConfig';

const restoMenuConfig = [
  {
    title: 'Entradas',
    engTitle: 'Starters',
    component: SingleSectionTable,
    img: carta4,
    items: [
      { text: 'Papas al Horno', engText: 'Baked Potatoes', price: 5900 },
      {
        text: 'Papas al Horno c/ salsa 4 quesos',
        price: 8900,
        engText: 'Baked Potatoes with four cheese sauce',
      },
      { text: 'Papas fritas', engText: 'French fries', price: 5900 },
      { text: 'Papas fritas Grandes', engText: 'French fries', price: 7500 },
      {
        text: 'Papas fritas con cheddar chica',
        engText: 'French fries with cheddar cheese',
        price: 6500,
      },
      {
        text: 'Papas fritas con cheddar grande',
        engText: 'French fries with cheddar cheese',
        price: 8900,
      },
      {
        text: 'Revuelto gramajo',
        price: 7900,
        engText: 'French fries with scrambled eggs & ham',
      },
      {
        text: 'Revuelto gramajo grande',
        price: 11800,
        engText: 'French fries with scrambled eggs & ham',
      },
      {
        text: 'Mejillones a la provenzal',
        engText: 'Provencal mussels',
        price: 19500,
      },
      {
        text: 'Mariscos salteados',
        price: 22500,
      },
      // { text: 'Camarones a la pill', engText: 'Pil pil shrimp', price: '890' },
      { text: 'Empanadas de carne', engText: 'Meat empanadas', price: 1500 },
      // { text: 'Empanadas de camaron y queso', price: 380 },
      //{ text: 'Rana', engText: 'Sauteed frogs', price: '980' },
      { text: 'Rabas', engText: 'Fried squid rings', price: 22500 },
      { text: 'Langostinos apanados', engText: 'Fried prawns', price: 24900 },
      { text: 'Provoleta', engText: 'Grilled provolone', price: 12500 },
    ],
  },
  {
    title: 'Ensaladas',
    engTitle: 'Salads',
    component: TwoSectionTable,
    img: carta2,
    subSections: [
      {
        title: 'Ensaladas',
        engTitle: 'Salads',
        items: [
          {
            text: 'Ensalada verde',
            price: 7900,
            engText: 'Lettuce, rucula, chicory, cabbage',
          },
          {
            text: 'Rucula y parmesano',
            price: 7900,
            engText: 'Rucula, parmesan cheese',
          },
          {
            text: 'Ensalada mixta',
            engText: 'Lettuce, tomato, carrot',
            price: 7900,
          },
          {
            text: 'Ensalada tropical',
            price: 14900,
            engText:
              'Lettuce, tomato, carrot, onion, ham, cheese, anana, chicory, cabbage & rucula',
          },
        ],
      },
    ],
  },
  {
    title: 'Especiales',
    engTitle: 'Specials',
    component: SingleSectionTable,
    img: carta3,
    items: [
      { text: 'Carne a la olla', engText: 'Beaf stew', price: 21900 },
      { text: 'Conejo a la calabresa', price: 32000 },
      { text: 'Conejo al ajillo', price: 32000 },
      { text: 'Rana frita', price: 32000 },
      // { text: 'Cordero a la cacerola', engText: 'Lamb stew', price: 21800 },
      // { text: 'Chivo a la cacerola', engText: 'Lamb stew', price: 19900 },
      // { text: 'Costeleta de cerdo a la riojana', price: 2900 },
      // { text: 'Paella', price: 3900 },
    ],
  },
  {
    title: 'Pastas',
    component: TwoSectionTable,
    img: carta5,
    subSections: [
      {
        title: '',
        items: [
          {
            text: 'Spaghetti',
            price: 15800,
          },

          {
            text: 'Sorrentinos de jamon y queso',
            engText: 'Pasta filled with ham',
            price: 18900,
          },
          // {
          //   text: 'Sorrentinos de calabaza y muzarella',
          //   engText: 'Pasta filled with pumpkin and cheesse',
          //   price: 17900,
          // },
          // {
          //   text: 'Panzotti de osobuco al malbec',
          //   engText: 'Pasta filled with meat',
          //   price: 17900,
          // },
          // {
          //   text: 'Panzotti de bondiola',
          //   price: 17900,
          // },
          {
            text: 'Ravioles ',
            engText: ' ravioli',
            price: 18900,
          },
          { text: 'Ñoquis', engText: 'Gnocchi', price: 15800 },
          {
            text: 'Canelones de choclo',
            engText: 'Corn canelloni',
            price: 15800,
          },
          {
            text: 'Canelones de verdura',
            engText: 'Vegetable canelloni',
            price: 15800,
          },
          {
            text: 'Canelones de pollo ricota y verdura',
            engText: 'Vegetable, ricotta & chicken canelloni',
            price: 15800,
          },
          {
            text: 'Lasagna de jamón y queso',
            engText: 'Ham & cheese lasagna',
            price: 18900,
          },
        ],
      },
      {
        title: 'Salsas',
        engTitle: 'Sauces',
        items: [
          { text: 'Cuatro quesos', engText: 'Four cheese sauce', price: 4000 },
          { text: 'Roquefort', engText: 'Roquefort sauce', price: 4000 },
          {
            text: 'Carusso',
            engText: 'Cream, ham, chicken, champignon',
            price: 5500,
          },
          { text: 'Alfredo', engText: 'Cream & ham', price: 4000 },
          {
            text: 'Mariscos salteados',
            engText: 'Sauteed seafood',
            price: 12000,
          },
          { text: 'Camarones', engText: 'Prawns & cream', price: 8500 },
          { text: 'Champignon', engText: 'Champignon & cream', price: 4000 },

          { text: 'Verdeo', engText: 'Green onion & cream', price: 4000 },
          { text: 'Estofado', price: 4000 },
          //{ text: 'Albahaca', engText: 'Basil & cream', price: '200' },
        ],
      },
    ],
  },
  {
    title: 'Carnes',
    engTitle: 'Meats',
    component: TwoSectionTable,
    img: carta6,
    subSections: [
      {
        title: '',
        items: [
          { text: 'Lomito', engText: 'Tenderloin sandwich', price: 22000 },
          // { text: 'Bife de lomo', engText: 'Tenderloin beef', price: 19900 },
          {
            text: 'Bife de chorizo',
            engText: 'Tenderloin steak',
            price: 24900,
          },

          { text: 'Milanesa', engText: 'Breaded meat', price: 18500 },
          {
            text: 'Milanesa suiza',
            engText: 'Breaded meat with cheese',
            price: 19000,
          },
          {
            text: 'Milanesa napolitana',
            price: 21500,
            engText: 'Breaded meat with ham, cheese & tomato sauce',
          },
          {
            text: 'Matambre a la pizza',
            price: 21900,
            engText: 'flank meat with ham, cheese & tomato sauce',
          },
          // {
          //   text: 'Costeletas de cerdo',
          //   price: 3000,
          // },
        ],
      },
      {
        title: 'Salsas',
        engTitle: 'Sauces',
        items: [
          { text: 'Mostaza', engText: 'Mustard sauce', price: 4000 },
          { text: 'Pimienta', engText: 'Pepper sauce', price: 4000 },
          { text: 'Champignon', engText: 'Champignon sauce', price: 4000 },
          { text: 'Cuatro quesos', engText: 'Four cheese sauce', price: 4000 },
        ],
      },
    ],
  },
  {
    title: 'Aves',
    engTitle: 'Poultry Meat',
    component: TwoSectionTable,
    img: carta1,
    subSections: [
      {
        title: '',
        items: [
          {
            text: 'Deshuado de pollo',
            engText: 'Boneless chicken',
            price: 17500,
          },
          { text: 'Milanesa', engText: 'Breaded chicken', price: 17900 },
          {
            text: 'Milanesa napolitana',
            price: 20500,
            engText: 'Breaded chicken with ham, cheese & tomato sauce',
          },
          {
            text: 'Milanesa suiza',
            engText: 'Breaded chicken with cheese',
            price: 18900,
          },
        ],
      },
      {
        title: 'Salsas',
        engTitle: 'Sauces',
        items: [
          { text: 'Mostaza', engText: 'Moustard sauce', price: 4000 },
          { text: 'Verdeo', engText: 'Green onion & cream', price: 4000 },
          { text: 'Pesto', engText: 'Sauteed garlic & parsley', price: 4000 },
        ],
      },
    ],
  },
  {
    title: 'Pescados',
    engTitle: 'Fish',
    component: TwoSectionTable,
    img: carta7,
    subSections: [
      {
        title: '',
        items: [
          { text: 'Congrio', price: 18900 },
          { text: 'Filet de merluza', engText: 'Hake', price: 17900 },
          // { text: 'Pejerrey', engText: 'Hake', price: 22000 },
          { text: 'Trucha', engText: 'Trout', price: 21000 },
          { text: 'Salmón', engText: 'Salmon', price: 29000 },
          // { text: 'Lenguado', price: 7900 },
          // { text: 'Pacu', engText: 'Pacú', price: 1700 },
        ],
      },
      {
        title: 'Salsas',
        engTitle: 'Sauces',
        items: [
          {
            text: 'Mariscos salteados',
            engText: 'Sauteed seafood',
            price: 12500,
          },
          { text: 'Roquefort', engText: 'Roquefort sauce', price: 4000 },
          { text: 'Cuatro quesos', engText: 'Four cheese sauce', price: 4000 },
          { text: 'Camarones', engText: 'Prawns & cream', price: 8500 },
        ],
      },
    ],
  },
  {
    title: 'Parrilla',
    engTitle: 'Roasted Meats',
    component: SingleSectionTable,
    img: carta8,
    items: [
      {
        text:
          'Porción de parrilla (asado de tira, chorizo, morcilla y chinchules)',
        price: 25900,
        engText:
          'Portion of roasted meats - short ribs, pork sausage, blood sausage and chitlins',
      },
      { text: 'Tira de asado', engText: 'Short ribs', price: 21900 },
      // {
      //   text: 'Porcion de molleja',
      //   price: 13900,
      // },
      {
        text: 'Porcion de chinchulines',
        price: 8900,
      },
    ],
  },
  {
    title: 'Bebidas',
    engTitle: 'Cold Drinks',
    component: SingleSectionTable,
    img: carta9,
    items: [
      { text: 'Gaseosa 500cc', engText: 'Soda', price: 2900 },
      { text: 'Gaseosa 1,5lt', engText: 'Soda 1,5lt', price: 7900 },
      { text: 'Agua 500cc', engText: 'Water', price: 2900 },
      {
        text: 'Agua saborizada - Pomelo, naranja, manzana, pera',
        price: 2900,
        engText: 'Flavored water',
      },
      { text: 'Cerveza Andes 970 cc', engText: 'Andes beer', price: 9500 },
      { text: 'Cerveza Quilmes 970 cc', engText: 'Andes beer', price: 9500 },
      {
        text: 'Cerveza Andes Origen 970 cc',
        engText: 'Andes Origin beer',
        price: 10000,
      },
      {
        text: 'Cerveza Stella Artois 970 cc',
        engText: 'Stella Artois beer',
        price: 10000,
      },
      {
        text: 'Cerveza Stella Artois 330 cc',
        engText: 'Stella Artois beer',
        price: 4500,
      },

      { text: 'Cerveza Corona 710 cc', engText: 'Corona beer', price: 10000 },
      { text: 'Cerveza Corona 330 cc', engText: 'Corona beer', price: 5000 },
      //{ text: 'Pinta de cerveza tirada', engText: 'Beer pint', price: 150 },
    ],
  },
  {
    title: 'Postres',
    engTitle: 'Desserts',
    component: SingleSectionTable,
    img: carta10,
    items: [
      { text: 'Ensalada de frutas', engText: 'Fruit salad', price: 4200 },
      {
        text: 'Helado - Casata, almendrado, suizo, escocés -',
        price: 4500,
        engText: 'Ice cream',
      },
      { text: 'Flan', price: 4400 },
      // { text: 'Mil hojas con nuez', price: 2900 },
      { text: 'Frutilla con crema', price: 9900 },
      // { text: 'Tartín de frutilla', price: 3000 },
      { text: 'Duraznos al natural', engText: 'Natural peaches', price: 4000 },
      { text: 'Queso y dulce', price: 4200 },
      { text: 'Peras al malbec', price: 4200 },
      // { text: 'Budín de pan', price: 3200 },
    ],
  },
  vinoConfig,
];

export default restoMenuConfig;
